import amapi from '@/api/amapi'

const initialState = () => ({
  tickets: [],
  ticketsPopulated: false,
  ticket: {},
  supportToken: '',
  loadingSupportToken: false
})

const state = initialState

const getters = {
  tickets: state => state.tickets,
  ticketsPopulated: state => state.ticketsPopulated,
  ticket: state => state.ticket,
  supportToken: state => state.supportToken,
  loadingSupportToken: state => state.loadingSupportToken,
}

const mutations = {
  POPULATE_TICKETS (state, tickets) {
    state.tickets = tickets
    state.ticketsPopulated = true
  },
  SET_TICKET (state, payload) {
    state.ticket = { ...payload }
  },
  SET_SUPPORT_PIN (state, token) {
    state.supportToken = token
  },
  SET_LOADING_SUPPORT_TOKEN (state, loading) {
    state.loadingSupportToken = loading
  },
  CLEAR_SUPPORT_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

const actions = {
  async getTickets ({ commit }) {
    try {
      const response = await amapi.makecall('ticket_list')
      commit('POPULATE_TICKETS', response.tickets)
    } catch (e) {
      throw e
    }
  },
  async getTicket ({ commit }, ticket_id) {
    try {
      const data = {
        ticketmaskid: ticket_id
      }

      const response = await amapi.makecall('ticket_get', { ...data })
      commit('SET_TICKET', response)

      return response
    } catch (e) {
      throw e
    }
  },
  async validateTicket ({ dispatch }, { ticket_id, serviceID }) {
    try {
      const data = {
        action: 'validate',
        ticketmaskid: ticket_id,
        serviceID
      }

      await amapi.makecall('ticket_update', data)

      await dispatch('getTicket', ticket_id)
      return Promise.resolve('Ticket validated')
    } catch (e) {
      throw new Error(e)
    }
  },
  async sendReply ({ dispatch }, data) {
    try {
      const response = await amapi.makecall('ticket_update', { ...data })

      await dispatch('getTicket', data.ticketmaskid)

      return response
    } catch (e) {
      throw e
    }
  },
  async createTicket ({ dispatch }, payload) {
    try {
      const response = await amapi.makecall('ticket_create', { ...payload })

      dispatch('getTickets', true)

      return response
    } catch (e) {
      throw e
    }
  },
  async requestCloseTicket ({ dispatch }, ticket_id) {
    try {
      const data = {
        action: 'close',
        ticketmaskid: ticket_id
      }
      const response = await amapi.makecall('ticket_update', { ...data })

      await dispatch('getTicket', ticket_id)
      return response
    } catch (e) {
      throw e
    }
  },
  async getSupportToken ({ commit }) {
    try {
      commit('SET_LOADING_SUPPORT_TOKEN', true)
      const response = await amapi.makecall('support_token')
      if (response?.support_token) {
        commit('SET_SUPPORT_PIN', response.support_token)
        setTimeout(() => {
          commit('SET_SUPPORT_PIN', '')
        }, 900000) // 15min
      }
      return response
    } catch (e) {
      throw e
    } finally {
      commit('SET_LOADING_SUPPORT_TOKEN', false)
    }
  },
  async ticketFeedback ({ commit }, payload) {
    try {
      return await amapi.makecall('ticket_feedback', payload)
    } catch (e) {
      throw e
    }
  }
}
const module = {
  state,
  getters,
  mutations,
  actions
}

export default module
